import { render, staticRenderFns } from "./Exports.vue?vue&type=template&id=122f0275&"
import script from "./Exports.vue?vue&type=script&lang=js&"
export * from "./Exports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('122f0275')) {
      api.createRecord('122f0275', component.options)
    } else {
      api.reload('122f0275', component.options)
    }
    module.hot.accept("./Exports.vue?vue&type=template&id=122f0275&", function () {
      api.rerender('122f0275', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Exports.vue"
export default component.exports